//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../Features/Features.SheetMetal.MultiThicknessBuilder.js";
import "../no/Expression.js";
import "../no/Features.js";
let d=[[[0,"IsSecondary",1,0],[0,"MaterialSide",1,0],[0,"MultiBendPropertiesList",0,"Features.SheetMetal.FeatureBendPropertiesListBuilder",0],[1,"MultiThicknessProperty",0,"Features.SheetMetal.MultiThicknessBuilder",0],[0,"Section",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"TargetBody",1,"Body",0],[1,"Thickness",0,"Expression",0],[0,"ThicknessSide",1,0]],[[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0],[[],"UpdateReferenceCurves",{R_:{transformer:"Features.Feature"}},0,0]],[]];
SPLM.Features.SheetMetal.TabBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.TabBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.TabBuilder.ThicknessSideOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.TabBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;